<p-card class="wo-card" [ngClass]="{'multiday': workOrder.isMultiday, 'grayOverlay': shouldDisableWODrag}" (click)="dblclickHandler()">
  @if (workOrder) {
    <p-header class="container">
      <div class="wo-header row">
        <div class="zip-code col-6"
          [style.background]="getZipBackgroundColor()"
          [style.color]="getZipColor()">
          {{workOrder.address?.zip}}
        </div>
        <div class="status col-6" (mouseenter)="datePanel.toggle($event)" (mouseleave)="datePanel.toggle($event)"
          [style.background]="getPriorityBackgroundColor()"
          [style.color]="getPriorityColor()"
          style="overflow: hidden;">
          {{workOrder.mostUrgentPriorityLevel?.status}}
          <p-popover #datePanel [appendTo]="'body'">
            <div>
              {{workOrder.mostUrgentPriorityLevel?.status}}
            </div>
            @if (workOrder.completionStatus != 'Completed' && workOrder.completionStatus !='Unable to be Completed') {
              <div>
                @for (task of unscheduledTasks; track task) {
                  <span>
                    @if (!task.workTask.isGoBack) {
                      <div>
                        {{getDueDateDisplay(task.workTask)}}
                      </div>
                    }
                    @if (task.workTask.isGoBack) {
                      <div>
                        GO BACK
                      </div>
                    }
                  </span>
                }
              </div>
            }
          </p-popover>
        </div>
      </div>
    </p-header>
  }

  <div class="customer-name">
    <a [routerLink]="" (click)="navigateToWorkOrder()" class="blue-link">{{workOrder.quoteNumber}}</a> @if (workOrder.isMultiday) {
    <span>- Multiday</span>
    }<br>
    {{customCustomerService.getCustomerFullName(workOrder.customer)}} @if (showMap) {
    <i class="fa fa-map-marked-alt" (click)="openMap()"></i>
    }<br />
    @if (hasCompanyWideNotes) {
      <i class="fa fa-sticky-note" (click)="op.toggle($event)"></i>
    }
    <p-popover #op>
      <app-customer-comment-view-only [customer]="workOrder.customer"></app-customer-comment-view-only>
    </p-popover>
  </div>

  <div class="equipment-type">
    {{ equipmentTypeDisplay }}
  </div>

  <div class="toggle-more-information">
    <div class="left" (click)="taskPanel.toggle($event)">
      {{scheduledTasksTotal}}/{{workOrder.workOrderWorkTasks.length}}
      <p-popover #taskPanel appendTo="body">
        <div class="center bold">Work Tasks</div>
        @for (woWorkTask of workOrder.workOrderWorkTasks; track woWorkTask) {
          <div>
            <span class="left">{{woWorkTask.workTask.name}}</span>@if (woWorkTask.workTask.scheduleDateFrom) {
            <i class="pi pi-star middle"
              [pTooltip]="woWorkTask.workTask.scheduleDateFrom | date: 'shortDate'"
            ></i>
          }
        </div>
      }
    </p-popover>
  </div>
  @if (isCollapsed) {
    <div>
      <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
        +
      </span>
    </div>
  }
  @if (!isCollapsed) {
    <div>
      <span (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed" class="plus-minus-span">
        -
      </span>
    </div>
  }
  <div [ngbCollapse]="isCollapsed" class="more-information">
    <div [id]="'woTaskList-' + workOrder.id" cdkDropList [cdkDropListData]="unscheduledTasks" [cdkDropListDisabled]="!canDrag"
      [cdkDropListConnectedTo]="dragAndDropService.bucketWOListIds" cdkDropListSortingDisabled="true">
      @for (woWorkTask of unscheduledTasks; track woWorkTask) {
        <div class="inner-card" cdkDrag
          (cdkDragStarted)="dragStart(woWorkTask, $event)" (cdkDragEnded)="taskDragEnd()"
          [cdkDragDisabled]="shouldDisableTaskDrag(woWorkTask.workTask)">
          <app-task-card [task]="woWorkTask.workTask" [isDisabled]="shouldDisableTaskDrag(woWorkTask.workTask)" [showPrice]="!workOrder.hidePrice || canSeeHiddenPrice"></app-task-card>
        </div>
      }
    </div>
  </div>
</div>

@if (workOrder) {
  <div class="card-footer">
    @if (workOrder.completionStatus) {
      <span>{{workOrder.completionStatus}}</span>
    }
    <hr style="padding: 0px; margin: 0px;"/>
    <span>@if (!workOrder.hidePrice || canSeeHiddenPrice) {
      <span>{{priceSummary | currency}} <i class="pi pi-circle-on" style="font-size: .5em;"></i></span>
    } {{hoursSummary}} {{unit}}</span>
  </div>
}
</p-card>
